"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// 默认request headers
var _default = function _default(url, options) {
  var _options$headers = options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers;
  var defaultRequestHeaders = window._defaultRequestHeaders_ || {};
  options.headers = Object.assign(defaultRequestHeaders, headers || {});
  return {
    url: url,
    options: options
  };
};

exports.default = _default;